import { Component, OnInit, HostListener } from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import {commonService} from "../../service/common.service";
import { Http, ResponseContentType } from '@angular/http';

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-packagedetail',
  templateUrl: './packagedetail.component.html',
  styleUrls: ['./packagedetail.component.css'],
  providers: [TestSeriesService,commonService],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide',   style({
        opacity: 0,
        transform: "translateX(-100%)"
      })),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
]
})

export class PackagedetailComponent implements OnInit {
  typetxt:any;
  paperDetail:any;
  totalrow:any = 0;
  notfound:any;
  isPostLoad:any;
  msg:any;
  isRemaningForum:any;
  postId:any=0;
  ngload:any;
  userData=0;
  filter:any;
  noMoreResults:any;
  isError=false;
  attactmentlist:any=[];
  questionCount:any=[];

  constructor(private http:Http, private testseriesservice:TestSeriesService, private router:Router, private route: ActivatedRoute, private global: Globals,private commonService:commonService) { 
    this.paperDetail = {
                        title:'',
                        testSery:{},
                        detail:'',
                        maxMarks:'',
                        publishDate:'',
                        submissionDate:'',
                      };
    this.route.params.subscribe((params: Params) => {
      if(params['id']){      
      this.postId = parseInt( atob(params['id']) ) ;
      if(isNaN(this.postId)){
        this.postId=0;
      } 

        if(this.postId >0){
          this.gettestpaperdata();
        } 
      }
    });

    this.userData = this.commonService.user.id;
  }

  ngOnInit() {
  }

  gettestpaperdata(){
    var obj = {};
    obj['id'] = this.postId;
    this.testseriesservice.gettestpaperdata(obj).subscribe((data:any)=>{
      
      if(data.error==0){ 
        this.paperDetail =data.results[0];

        var structure = this.paperDetail.testPaperStructures;
        if(structure.length>0){
          for(let s of structure){
            if(s.parentLevel==1) this.questionCount.push(s);
          }
        }

        console.log('ffff',this.paperDetail);
        //this.paperDetail.uploadFiles;
      }
    },
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    })
  }
  
  getTPpdf(imagename){
    return this.global.testseriesImageUrl+imagename;
    
  }

  downloadAttachment(attachmentObj){
    
    /*if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } */
   

    var url=this.global.testseriesImageUrl+attachmentObj.fileName;
    return this.http.get(url,{
      responseType: ResponseContentType.Blob,
    })
    .map(res => {
      return {
        filename: attachmentObj.fileName,
        data: res.blob()
      };
    }).subscribe(res => {
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }, error => {
        //console.log('download error:', JSON.stringify(error));
             if(error.status="404"){
                    alert('Something went wrong. Please try to latter.');
             }
      }, () => {
       // console.log('Completed file download.')
      });


   

  }

}




// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/packagedetail/packagedetail.component.ts